<!--工单详情-->
<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="知识详情" size="75%" :before-close="handleClose" :visible.sync="drawer"
               direction="rtl" append-to-body custom-class="demo-drawer" ref="drawer" class="details2">
      <div class="demo-drawer__content">
        <template>
          <div>
            <!-- 服务商 -->
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">

                  </div>
                </div>
                <div class="d-cont edit-mce-box">
                  <div class="d-item">
                    <div class="title first">
                      <!-- <b><span>节点图</span></b> -->
                    </div>
                    <div style="padding: 0 10px;">
                      <div class="title">{{ formData.title }}</div>
                      <div class="source"> {{ formData.createTime }} <span>关键字：{{ formData.keyWords }}</span>
                        <span>类别：{{formData.knowledgeTypeName}}</span> <span>资料链接：{{formData.linkUrl}}</span>
                        <span>已解决量：{{formData.solvedCount}}</span></div>
                        <!-- <div class="source"> <span>资料链接：{{formData.linkUrl}}</span></div> -->
                      <div v-html="formData.content"></div>
                      <!-- 附件 -->
                      <div class="d-item" style="height: 280px; ">
            <el-row :gutter="40">
              <el-col :span="10">
                <div class="title first" style="text-align: start;">
                  <b>附件信息</b>

                </div>
                <div class="current-info">
                  <vxe-table ref="filterTable"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow
                             :data="fileList"
                  >
                    <vxe-column field="name" title="附件名称" width="">
                      <template #default="{row}">
                        <!-- <a :href="row.url" :download="row.name">{{row.name}}</a> -->
                        <span @click="openVideo(row.url)">{{ row.name }}</span>

                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">





<template #default="{ row }">
  <!-- 下载 -->
  <div>

  </div>

  <div>
    <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="handleDownload(row.name, row.url)" class="el-icon-download"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

    <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
      popper-class="tooltip-skin">
      <i @click="openVideo(row.url)" class="el-icon-view"
        style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
    </el-tooltip>
  </div>
</template>
</vxe-column>

                  </vxe-table>
                </div>
              </el-col>
              <!-- <el-col :span="10">
                <div class="title first"
                style="text-align: start;">
                  <b>故障现象</b>

                </div>
                <div class="current-info">
                  <vxe-table ref="filterTable" height="220"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow
                             :data="formData.basKnowledgeFaultList"
                             @checkbox-all="selectChangeEvent1"
                             @checkbox-change="selectChangeEvent1"
                  >
                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="symptomCode" title="故障现象编码"/>
                    <vxe-column field="symptomName" title="故障现象名称"/>

                  </vxe-table>
                </div>
              </el-col> -->
            </el-row>
          </div>
                    </div>
                  </div>

                  <div style="height: 10px;"></div>
                </div>

              </el-form>
            </div>
          </div>
        </template>

      </div>
    </el-drawer>
        <!-- 文件预览 -->
        <Preview v-if="showPreview" @closeD="closeD" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />
  </div>
</template>
<script>
import api from "@/api/projectApi";
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
export default {
  inject: ['reload'],
  name: 'detailDialog',
  props: ['multi', 'row1'],
  components: { Preview,},
  created() {
    this.dataId = this.row1
    console.log(this.dataId, "传过来的值");
  },
  data() {
    return {
      imgVisbleURL: '',

showPreview: false,
      fileList: [],

      dataId: '',
      drawer: true,
      formData: {},
    }
  },
  mounted() {
    this.getData();
    console.log(this.dataId, "_dataId的值");
  },
  methods: {
    closeD() {
      this.showPreview = false

    },
        // 文件下载
        handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
        // 文件预览
        openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.$http.post(api.basKnowledge.getDataUrl, {id: this.dataId}).then(res => {
          this.formData = res.data.data
          let  data=this.formData

          this.fileList = []
          if (data.file1) {
            this.fileList.push({url: data.file1, name: data.fileName1})
          }
          if (data.file2) {
            this.fileList.push({url: data.file2, name: data.fileName2})
          }
          if (data.file3) {
            this.fileList.push({url: data.file3, name: data.fileName3})
          }
          if (data.file4) {
            this.fileList.push({url: data.file4, name: data.fileName4})
          }
          if (data.file5) {
            this.fileList.push({url: data.file5, name: data.fileName5})
          }
        })
      }
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }
}

.title {
  text-align: center;
  font-size: 30px;
  margin: 10px 0
}

.source {
  color: #a7a7a7;
  margin-bottom: 10px;
  font-size: 16px;

  span {
    margin-left: 20px;
  }
}

.el-image {
  margin: 10px 0;
}
</style>
